import { render, staticRenderFns } from "./BehaviorsForm.vue?vue&type=template&id=109ab07d&scoped=true&"
import script from "./BehaviorsForm.vue?vue&type=script&lang=js&"
export * from "./BehaviorsForm.vue?vue&type=script&lang=js&"
import style0 from "./BehaviorsForm.vue?vue&type=style&index=0&id=109ab07d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109ab07d",
  null
  
)

export default component.exports